import React, { useState } from 'react'
import { Route, Switch, useHistory, Link } from 'react-router-dom'
import { Card, Col, Row, Statistic, DatePicker } from 'antd'
import moment from 'moment'

const { RangePicker } = DatePicker

// import {UserOutlined } from '@ant-design/icons';

const Home = () => {

    const selectRange = range => {
        setRanges(range)
    }

    const search = str => {
        setString(str)
        if (str?.trim().length > 2 || str.length === 0)
            return
    }
    const [string, setString] = useState('')
    const [ranges, setRanges] = useState()

    return (
        <div className="px-4 sm:px-6 lg:px-8 py-8 w-full max-w-9xl mx-auto">
            <header className="border-b border-gray-100 flex justify-between items-center pt-4">
                <h2 className="font-semibold text-gray-800 pl-4">Message Statistics</h2>
            </header>
            <Card boardered={false}
                className="bg-white shadow-lg rounded-sm border border-gray-200 px-6 py-4"
                style={{
                    textAlign: 'center'
                }}>
                <Row gutter={16}>
                    <Col span={6}>
                        {/* <Statistic title="Feedback" value={1128} prefix={<LikeOutlined />} /> */}
                        <Statistic title="SENT" value={1128} />
                    </Col>
                    <Col span={6}>
                        <Statistic title="IN-QUEUE" value={1128} />
                    </Col>
                    <Col span={6}>
                        <Statistic title="SCHEDULED" value={1128} />
                    </Col>
                    <Col span={6}>
                        <Statistic title="FAILED" value={1128} />
                    </Col>
                </Row>
            </Card>
            {/* <div className="col-span-full xl:col-span-8 bg-white shadow-lg rounded-sm border border-gray-200 px-6 py-4"> */}
            <header className="border-b border-gray-100 flex justify-between items-center pt-4">
                <h2 className="font-semibold text-gray-800 pl-4">Refferals</h2>
            </header>
            {/* Out of 24 divide into 8 : 16 */}
            <div className="flex justify-between items-center mt-1 mb-5">
                <input
                    onChange={e => search(e.target.value)}
                    className="appearance-none block max-w-4xl bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white"
                    id="grid-inv-item"
                    type="text"
                    placeholder="Search Recent Refferals" />
                <span className="flex items-center">
                    <RangePicker
                        onChange={selectRange}
                        ranges={{
                            'Today': [moment().startOf('day'), moment().endOf('day')],
                            'Yesterday': [moment().subtract(1, 'day').startOf('day'), moment().subtract(1, 'day').endOf('day')],
                            'This Week': [moment().startOf('week'), moment().endOf('week')],
                            'This Month': [moment().startOf('month'), moment().endOf('month')],
                        }} />
                </span>
            </div>
            <Row >
                <Col span={8}
                    className="pr-4">
                    <Card title="RECENT REFFERALS"
                        className="bg-white shadow-lg rounded-sm border border-gray-200 px-6 py-4"
                        size="small">
                        <p>Card content</p>
                        <p>Card content</p>
                        <p>Card content</p>
                        <p>Card content</p>
                        <p>Card content</p>
                        <p>Card content</p>
                        <p>Card content</p>
                        <p>Card content</p>
                        <p>Card content</p>
                        <p>Card content</p>
                    </Card>
                </Col>
                
                <Col span={16}>
                    <Card title="PENDING REFFERAL REQUESTS"
                        className="bg-white shadow-lg rounded-sm border border-gray-200 px-6 py-4"
                        size="small" >
                        <p>Card content</p>
                        <p>Card content</p>
                        <p>Card content</p>
                        <p>Card content</p>
                        <p>Card content</p>
                        <p>Card content</p>
                        <p>Card content</p>
                        <p>Card content</p>
                        <p>Card content</p>
                        <p>Card content</p>
                    </Card>
                </Col>
            </Row>
        </div>
    )
}

export default Home 